<script setup>
const props = defineProps({
	icon: {
		type: String,
		required: true,
	},
})
</script>

<template>
	<div class="flex w-full flex-row items-center justify-between border-white/20 p-3 xs:h-32 xs:flex-col xs:items-start xs:border-b-0 xs:pr-10 [&:not(:last-child)]:border-b xs:[&:not(:last-child)]:border-b-0 xs:[&:not(:last-child)]:border-r">
		<div class="flex h-7 w-7 items-center justify-center rounded-full bg-white text-sm text-black xs:h-9 xs:w-9 xs:text-base">
			<i :class="icon"></i>
		</div>
		<p class="flex gap-1 leading-[1.2] xs:flex-col xs:gap-0"><slot /></p>
	</div>
</template>
